import { lazy } from 'react';
import type { AppRoute } from 'src/shared/routes';

const CalendarPage = lazy(() => import('./CalendarPage'));

export const appointmentsRoutes: AppRoute[] = [
  { path: '/agenda', name: 'Agenda', element: CalendarPage },
];
